export const PAGE_URL = {
  LOGIN: '/auth/login',
  DASHBOARD: '/dashboard',
  OWNER_DASHBOARD: '/owner',
  // DiOwner — 6 báo cáo dành cho chủ đầu tư (scaffold, nối API sau).
  OWNER_REPORTS: {
    INDEX: '/reports',
    REVENUE: '/reports/revenue',
    SEGMENT: '/reports/segment',
    OCCUPANCY: '/reports/occupancy',
    FORECAST: '/reports/forecast',
    AGENCY: '/reports/agency',
    COMPARE: '/reports/compare',
  },
  ROOM_MAP: '/',
  ROOM_AVAILABILITY: '/room-availability',
  BOOKING: '/booking',
  BOOKING_EXELY: '/booking-exely',
  CAMPAIGN_EXELY: '/campaign-exely',
  NIGHT_AUDIT: '/night-audit',
  BILL_VAT: '/bill-vat',
  CHECKOUT: '/check-out',
  ROOM_PLAN: '/roomplan',
  LOG_HISTORY: '/log-history',
  ROOM_STANDARD_PRICE: '/room-standard-price',
  PERMISSION: '/permission',
  SERVICE_MANAGER: '/service-manager',
  PAYMENT_MANAGER: '/payment-manager',
  HOTEL_MANAGER: '/hotel-manager',
  PRODUCT_HK_DEFINITION: '/product-hk-definition',
  TOTAL_MANAGER: '/total-manager',
  REPORT: '/report',
  REPORT_PO: '/report-po',
  HOUSEKEEPING: {
    ROOM_ASSIGNMENT: '/room-assignment',
    ROOM_STATUS: '/room-status',
  },
  REPORTS: {
    REPORT_MANAGEMENT: 'report-management',
    TOTAL_REVENUE_REPORT: 'total-revenue-report',
    TOTAL_REVENUE_BY_SERVICE_REPORT: 'total-revenue-detail-by-service-report',
    REVENUE_STATISTICS_REPORT_BY_MARKET_SEGMENT:
      'revenue-statistics-report-by-market-segment',
    ROOM_USAGE_REPORT: 'room-usage-report',
    TRAVEL_AGENCY_PRODUCTIVITY_REPORT: 'travel-agency-productivity-report',
    TRAVEL_AGENCY_PRODUCTIVITY_DETAIL_REPORT:
      'travel-agency-productivity-detail-report',
    GUEST_LIST_CHECK_IN_REPORT: 'guest-list-check-in-report',
    GUEST_LIST_CHECK_OUT_REPORT: 'guest-list-check-out-report',
    GUEST_LIST_IN_HOUSE_REPORT: 'guest-list-in-house-report',
    ROOM_LIST_ARRIVAL_REPORT: 'room-list-arrival-report',
    ROOM_LIST_DEPARTURE_REPORT: 'room-list-departure-report',
    ROOM_LIST_IN_HOUSE_REPORT: 'room-list-in-house-report',
    WEEKLY_ROOM_REPORT: 'weekly-room-report',
    GUEST_STATISTICS_REPORT_BY_NATIONALITY:
      'guest-statistics-report-by-nationality',
    EXPECTED_BREAKFAST_GUESTS_REPORT: 'expected-breakfast-guests-report',
    RECEPTIONIST_CASHIER_REPORT: 'receptionist-cashier-report',
    DEPOSIT_TRANSFER_REPORT: 'deposit-transfer-report',
    INVOICE: 'invoice',
    PRINT_ELECTRONIC_INVOICE_VAT: 'print-electronic-invoice-vat',
  },
  SYSTEM: {
    TRANSLATION: 'translation',
    CONFIGURATION: 'configuration',
    CMS_SETTING: 'cms-setting',
  },
  AUTH: {
    INDEX: 'auth',
    LOGIN: 'login',
  },
  REDIRECT: 'redirect',
};

export const ROUTE = {
  REPORT: {
    INDEX: '/report',
    TRAVEL_AGENCY_PRODUCTIVITY_REPORT: [
      '/report',
      PAGE_URL.REPORTS.TRAVEL_AGENCY_PRODUCTIVITY_REPORT,
    ].join('/'),
    ROOM_USAGE_REPORT: ['/report', PAGE_URL.REPORTS.ROOM_USAGE_REPORT].join(
      '/'
    ),
    RECEPTIONIST_CASHIER_REPORT: [
      '/report',
      PAGE_URL.REPORTS.RECEPTIONIST_CASHIER_REPORT,
    ].join('/'),
    EXPECTED_BREAKFAST_GUESTS_REPORT: [
      '/report',
      PAGE_URL.REPORTS.EXPECTED_BREAKFAST_GUESTS_REPORT,
    ].join('/'),
    TOTAL_REVENUE_REPORT: [
      '/report',
      PAGE_URL.REPORTS.TOTAL_REVENUE_REPORT,
    ].join('/'),
    REVENUE_STATISTICS_REPORT_BY_MARKET_SEGMENT: [
      '/report',
      PAGE_URL.REPORTS.REVENUE_STATISTICS_REPORT_BY_MARKET_SEGMENT,
    ].join('/'),
    DEPOSIT_TRANSFER_REPORT: [
      '/report',
      PAGE_URL.REPORTS.DEPOSIT_TRANSFER_REPORT,
    ].join('/'),
    GUEST_LIST_CHECK_IN_REPORT: [
      '/report',
      PAGE_URL.REPORTS.GUEST_LIST_CHECK_IN_REPORT,
    ].join('/'),
    GUEST_LIST_CHECK_OUT_REPORT: [
      '/report',
      PAGE_URL.REPORTS.GUEST_LIST_CHECK_OUT_REPORT,
    ].join('/'),
    GUEST_LIST_IN_HOUSE_REPORT: [
      '/report',
      PAGE_URL.REPORTS.GUEST_LIST_IN_HOUSE_REPORT,
    ].join('/'),
    GUEST_STATISTICS_REPORT_BY_NATIONALITY: [
      '/report',
      PAGE_URL.REPORTS.GUEST_STATISTICS_REPORT_BY_NATIONALITY,
    ].join('/'),
    ROOM_LIST_ARRIVAL_REPORT: [
      '/report',
      PAGE_URL.REPORTS.ROOM_LIST_ARRIVAL_REPORT,
    ].join('/'),
    ROOM_LIST_DEPARTURE_REPORT: [
      '/report',
      PAGE_URL.REPORTS.ROOM_LIST_DEPARTURE_REPORT,
    ].join('/'),
    ROOM_LIST_IN_HOUSE_REPORT: [
      '/report',
      PAGE_URL.REPORTS.ROOM_LIST_IN_HOUSE_REPORT,
    ].join('/'),
    WEEKLY_ROOM_REPORT: ['/report', PAGE_URL.REPORTS.WEEKLY_ROOM_REPORT].join(
      '/'
    ),
  },
  REDIRECT: ['', PAGE_URL.REDIRECT].join('/'),
  HELP_PORTAL: ['', PAGE_URL.REDIRECT].join('/') + '?url=',
};

export const NOT_ALLOW_SHOW_FOOTER_PAGE_URL = [
  PAGE_URL.ROOM_AVAILABILITY,
  PAGE_URL.PERMISSION,
  PAGE_URL.LOG_HISTORY,
  PAGE_URL.SERVICE_MANAGER,
  PAGE_URL.PAYMENT_MANAGER,
  PAGE_URL.HOTEL_MANAGER,
  PAGE_URL.PRODUCT_HK_DEFINITION,
];
